export const resourcesData = [  
  {
    id: 1,
    title: "Mechanics I",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1nu8LUMs8RmT5AKdSHEv-pvMVwIQw4LUl",
  },
  {
    id:2,
    title: "Mechanics II",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1RE_hBQogejGMxClAYYw9lQES4klRpAjd",
  },
  {
    id: 3,
    title: "Magnetism",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1AX-FJxu8EYcoE4LME9dRGZKuI2OWJHZY",
  },
  {
    id: 4,
    title: "Thermometry",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/17hlNXTFZiNuUGLNNMK6hMlSv-VbBQIcM",
  },
  {
    id: 5,
    title: "Electrostatics",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1W2YEoENQlhgLe2Ky_M-d2rA1cVc9Dbf6",
  },
  {
    id: 6,
    title: "Optics",
    type: "Reference Books",
    subject: "Physics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1muAo9SzSkFPfcjsj3fhJDCveyWul3f8G",
  },


  {
    id: 7,
    title: "Physical Chemistry I",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1C00WgC5fPhUFrGmfZ9xo5h_w4sMDahg_",
  },
  {
    id: 8,
    title: "Physical Chemistry II",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1o-Zpun8PFjvr2wAtmRGRb0ixVbr5Oar7",
  },
  {
    id: 9,
    title: "Inorganic Chemistry I",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1D_pdEgTWEFQ0rwJSS-hIgObM51rE9qYe",
  },
  {
    id: 10,
    title: "Inorganic Chemistry II",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1gWFrxlwQ_W-KEheqkCOKVvvb4QKQcoK3",
  },
  {
    id: 11,
    title: "Organic Chemistry I",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1IxXUj5wO2hdx3ID5G8lFDamomGu_KfdJ",
  },
  {
    id: 12,
    title: "Organic Chemistry II",
    type: "Reference Books",
    subject: "Chemistry",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1fpjU3VWAwOd8O8cVvWNkZPWWcA2cQA72",
  },

  
  {
    id: 13,
    title: "Trigonometry",
    type: "Reference Books",
    subject: "Mathematics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1XNLJuPpw-9wQ9MWnnEzJ_4Vfw16J6ZAH",
  },
  
  {
    id: 14,
    title: "Calculus",
    type: "Reference Books",
    subject: "Mathematics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1a_wPAXU_Q1fiyVtZFGLFQj3hx_eIomH-",
  },
  
  {
    id: 15,
    title: "3D Geometry",
    type: "Reference Books",
    subject: "Mathematics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1LJByflN76lAwqTR02NP9FGaiM9clri5s",
  },
  {
    id: 16,
    title: "Algebra",
    type: "Reference Books",
    subject: "Mathematics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1H6j6Ew3A0ntL971RTqpbkaJqsdIwdodG",
  },
  {
    id: 17,
    title: "Coordinate Geometry",
    type: "Reference Books",
    subject: "Mathematics",
    ReferenceBookSource: "Cengage",
    downloadUrl: "https://drive.google.com/drive/folders/1MSVkAlTy-ljQauWc0awJdO1wMf40YT2J",
  },
  // Practice Papers
  {
    id: 18,
    title: "Chemical Bonding 2",
    type: "Practice",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1m81vSNTEBYHPw_2SJ-VJg6aFfF_QnWCh/view?usp=drive_link",
  },
 {
    id: 19,
    title: "Equilibrium 2",
    type: "Practice",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/18wPaGQQKU31JlZvAfOMWoC5U6hd2EmG7/view?usp=drive_link"
 },
 {
    id: 20,
    title: "Relations and Functions 2",
    type: "Practice",
    subject: "Mathematics",
    downloadUrl: "https://drive.google.com/file/d/14m1390-vVzmqgoaqeHEMw7guyNylt24k/view?usp=drive_link"
 },
 {
    id: 21,
    title: "Electrostatics 2",
    type: "Practice",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1Mboxm38IM52dOgqVkm7CfEO8gCu7IUiy/view?usp=drive_link"
 },
 {
    id: 22,
    title: "Rotational Motion 2",
    type: "Practice",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1tu3JN8NBubZIrmCkGuJXhoUJEQk4I6iR/view?usp=drive_link"
 },
 {
    id: 23,
    title:"Semiconductor 2",
    type: "Practice",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1MBmybEUQaDIRgbC5aSUwdzuWMEUiH7km/view?usp=drive_link"
 },
 {
    id: 24,
    title: "Thermal Physics 2",
    type: "Practice",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1dFQN2vSgKh-gAum51kjgM8XNXIZmlBr1/view?usp=drive_link"
 },
 // Cheatsheets
  {
    id: 25,
    title: "Haloalkanes and Haloarenes",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/17kQbg8vycn02LjTNNw45rtgd96GB5b87/view?usp=drive_link"
  },
  {
    id: 26,
    title: "Hydrogen",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1lV89zgepRmXa0rUCmyXrg3efxU5-oK5F/view?usp=drive_link"
  },
  {
    id: 27,
    title: "Conic Sections",
    type: "Cheatsheets",
    subject: "Mathematics",
    downloadUrl: "https://drive.google.com/file/d/1SYTCaC9XrV41gLu2MutxfWhY-w-pD5Tx/view?usp=drive_link"
  },
  {
    id: 28,
    title: "Circular Motion",
    type: "Cheatsheets",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1NtnlcBpQ4IjJzkmUp_IlujrWKOs0h6gC/view?usp=drive_link"
  },
  {
    id: 29,
    title: "Current Electricity",
    type: "Cheatsheets",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1gMwhL9ApLqsQdoIdduc-MHubdrXkogH7/view?usp=drive_link",
  },
  {
    id: 30,
    title: "Kinematics",
    type: "Cheatsheets",
    subject: "Physics",
    downloadUrl: "https://drive.google.com/file/d/1bxTEGfNF146WKHQ64xLXMYX14UkH7Tgs/view?usp=drive_link",
  },
  {
    id: 31,
    title: "Matrices and Determinants",
    type: "Cheatsheets",
    subject: "Mathematics",
    downloadUrl: "https://drive.google.com/file/d/1tmcO4p4nbJ0l8Q8j0LTJKJ4mpqj4FGfU/view?usp=drive_link",
  },
  {
    id: 32,
    title: "Alcohols, Phenols and Ethers",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1sVpsbGy0MqRKLhuJRAkaFPdU4Rf1dhGj/view?usp=drive_link",
  },
  {
    id: 33,
    title: "Aldehydes, Ketones and Carboxylic Acids",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1sdcIZgPgYD7OfZ9KOsLdPnDJjvfrnDHI/view?usp=drive_link",
  },
  {
    id: 34,
    title: "Chemical Bonding",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1-tkhhgDSSXcZGthAgkixLN7zPf8h6ns1/view?usp=drive_link",
  },
  {
    id: 35,
    title: "d and f Block Elements",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1XujNDPq5FQ-NF0ZJJTUdGyH2qCwhe24H/view?usp=drive_link",
  },
  {
    id: 36,
    title: "Hydrocarbons",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1vFgQaWgwICP6ISJN_J0H-QEczH8Grx5z/view?usp=drive_link",
  },
  {
    id: 37,
    title: "Periodic Table",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1JxObHYROlvFyjqmi1PBaGcYF9ZK_NU_w/view?usp=drive_link",
  },
  {
    id: 38,
    title: "Solutions",
    type: "Cheatsheets",
    subject: "Chemistry",
    downloadUrl: "https://drive.google.com/file/d/1xuqZBsmuMFsdDKknwgiH0MiBKJd_O7Rs/view?usp=drive_link",
  },
  {
  id: 39,
  title: "IUPAC Nomenclature",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1R6mjJErf6338CJd2yOcmIFMuSd-KRZls/view?usp=drive_link",
},
{
  id: 40,
  title: "Limits, Continuity and Differentiability",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1egt5TLiuWkupNRkZtCwG_hX7mNwUsBN4/view?usp=drive_link",
},
{
  id: 41,
  title: "Differentiation",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1oCUfbouUJ356Lh__07-mee6_8iFngmbU/view?usp=drive_link",
},
{
  id: 42,
  title: "Application of derivatives",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1vuQHO415R3HDtyoSy7-6iv2a2OesllQP/view?usp=drive_link",
},
{
  id: 43,
  title: "Integration",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1NK9u9rCJajNw5y6-9Gl8JMxPtiftP_SU/view?usp=drive_link",
},
{
  id: 44,
  title: "Definite Integration",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1aXONwAIxe5MnnTllEkZ43lJyZMhB0rST/view?usp=drive_link",
},
{
  id: 45,
  title: "Differential Equations",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1bTo70lG8yAkxvE_6-hnAb89b3kOU3WQ-/view?usp=drive_link",
},
{
  id: 47,
  title: "Organic Chemistry Reactions Sheet",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1bYMCjB3y5pvnk_lWNefYdSgxIteN2zvK/view?usp=drive_link",
},
{
  id: 48,
  title: "Trigonometry",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1pKnN7-o9JuU8BxmFtPEnD8MKqpH9vAUU/view?usp=drive_link",
},
{
  id: 49,
  title: "Physical Chemistry Formula Sheet",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1ErbMjhJMHcJzEPf4iIJIeJoAMQZ10vSM/view?usp=drive_link",
},
{
  id: 50,
  title: "Rotational Motion",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1ByhgDryWE5gYHgfuEKtMtbGcJFKTuwQO/view?usp=drive_link",
},
{
  id: 51,
  title: "Errors in Measurement",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1APLvi0nTxY6no8JBObvGZdodCTyqUHIx/view?usp=drive_link",
},
{
  id: 52,
  title: "Biomolecules",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1L1atXX2Rph4Z4iaxPK3-HTeUQ-gxD6vt/view?usp=drive_link",
},
{
  id: 53,
  title: "Simple Harmonic Motion",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/192SofY71APFIlpgvv3RKLeiA6zm73rmz/view?usp=drive_link",
},
{
  id: 54,
  title: "Amines",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1NHfKxbKDkFpx4PPri36YdLCR9aLDYvfa/view?usp=drive_link",
},
{
  id: 55,
  title: "Statistics",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1ey0PTDyQdm2nLx2iZdiUYkdHGGaOHPAt/view?usp=drive_link",
},
{
  id: 56,
  title: "Electromagnetic Induction",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/105z0oZynAi9wA0AC2_bGUkIImsnnFuCF/view?usp=drive_link",
},
{
  id: 57,
  title: "AC Circuits",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1-Fw8UAof_GFVNUOYlYOd10xVGTSesmMP/view?usp=drive_link",
},
{
  id: 58,
  title: "Work, Energy and Power",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1qUXpUVKJaL7-ClBNI9LaoUAulj0av6bg/view?usp=drive_link",
},
{
  id: 59,
  title: "3D Geometry",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/124rn70UOvi-5tIXVZYppQanmsS7Fl28c/view?usp=drive_link",
},

{
    id:60,
    title: "JEE Mains Syllabus Tracker",
    type: "JEE Busters",
    subject: "All", 
    downloadUrl: "https://drive.google.com/file/d/1839JnZl1iIQhLAuTGLNkGeTXeWT5oQ3d/view?usp=drive_link",
},
{
    id:61,
    title: "Top-Scoring Concepts in Mathematics",
    type: "JEE Busters",
    subject: "All", 
    downloadUrl: "https://drive.google.com/file/d/1ZqNJHyn29fgs8pN0sVBzPtNe1ektpuA9/view?usp=drive_link",
},
,
{
    id:62,
    title: "Top-Scoring Concepts in Physics",
    type: "JEE Busters",
    subject: "All", 
    downloadUrl: "https://drive.google.com/file/d/1R8zXivnKoXbaSqJTVZeI6G_4eQHHEbIH/view?usp=drive_link",
},
{
  id: 63,
  title: "All physics instruments",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1MQM8gTPNx-lQz3RFnmmEijqz-p5kRuN_/view?usp=drive_link",
},
{
  id: 64,
  title: "Top Scoring Concepts in Chemistry",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1859b57_6GL6JyxS65-zIcg75niVkrzwp/view?usp=drive_link",
},
{
  id: 65,
  title: "Modern Physics",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1UIhrFyUGGqoDmbB6e6jgTMXWD4nioUND/view?usp=drive_link",
},
{
  id: 66,
  title: "Dual Nature of Matter",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1xbPwdP_TlvhFEyQ56ryyG2QDF3H1C_0j/view?usp=drive_link",
},
{
  id: 67,
  title: "Salt Analysis",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1pdcPNkg-wdBxjnfL4uP_6IjXyCHfKpFp/view?usp=drive_link",
},
{
  id: 68,
  title: "Vector Algebra",
  type: "Cheatsheets",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1cVzfIvHrWhr9OOlJWgnCQ5tUR9quoTti/view?usp=drive_link",
},
{
  id: 69,
  title: "Electrochemistry",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/16MnpibVSLcW32oQQqZbFnF5ZtNmca_P_/view?usp=drive_link",
},
{
  id: 70,
  title: "Isomerism",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1TgSBwyVz3KI3mhvY3WA9nfnhFf1AxO2h/view?usp=drive_link",
},
{
  id: 71,
  title: "Ray Optics",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1ZBU9ung1Qui8vl48tMf2CLRTOZWGaZRd/view?usp=drive_link",
},
{
  id: 72,
  title: "Wave Optics",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1iiu4nRC6DdVg2kQqxlQsdk3-FqHbOnN4/view?usp=drive_link",
},
{
  id: 73,
  title: "Fluid Mechanics",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/11jiQ-ZMpKcw9plXD7RN5hGt-I1tSFURE/view?usp=drive_link",
},
{
  id: 74,
  title: "Top Chapters for Class 11",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1yES42ZZ75w2bEgF6Jbjv5aH975vtq6I-/view?usp=drive_link",
},{
  id: 75,
  title: "JEE Advanced Syllabus Tracker",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/11uctifTPSRbVDQkr79gc5JY6M8m0DsFY/view?usp=drive_link",
},
{
  id: 76,
  title: "Coordination compounds",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1e2XvHzqwmyU_IIN4xcfoKciNZSsHZhD0/view?usp=drive_link",
},
{
  id: 77,
  title: "Electrostatics",
  type: "Cheatsheets",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1L9PYe_OD41PShyQOnmc_Fq57WQ-QEnw8/view?usp=drive_link",
},{
  id: 78,
  title: "Chemical kinetics",
  type: "Cheatsheets",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/15vgRnE2B6PL2v0-yk3QwlZbhgI43R9bR/view?usp=drive_link",
},
{
  id: 79,
  title: "Top Class 10 Foundation Guide",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/10Qn4J7BLikv_DOEKEpuNzWVZZaeSCel0/view?usp=drive_link",
},
{
  id: 80,
  title: "OP Tandon Physical Chemistry",
  type: "Reference Books",
  subject: "Chemistry",
  ReferenceBookSource: "OP Tandon Physical Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1L9gm6-MepFelfegUKND4jmIR-x3nH3qD/view?usp=drive_link",
},
{
  id: 81,
  title: "MS Chouhan Organic Chemistry",
  type: "Reference Books",
  subject: "Chemistry",
  ReferenceBookSource: "MS Chouhan Organic Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1DY9t1lkTpBheS1b25r7M-Omh-UfipdF1/view?usp=drive_link",
},
{
  id: 82,
  title: "Work, Energy and Power",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/16WcYVIQ8o0YJ_m06ay5yGGC00uUcQMuJ/view?usp=drive_link",
},
{
  id: 83,
  title: "Units and Measurements",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1MfNo-0cXydidnwqgqkb_9P-ALWCOc4at/view?usp=drive_link",
},
{
  id: 84,
  title: "Rotational Motion",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1EWS5aPX1VsAAsum-gEOw0aC-l1MzeIEE/view?usp=drive_link",
},
{
  id: 85,
  title: "Laws of Motion",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1N5XRfH7ZBqmligctHdNNmPeiBbFI-VVq/view?usp=drive_link",
},
{
  id: 86,
  title: "Kinematics",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1i_3EVvTqR6IGAvFAFPwb8AQsxlIAS2HI/view?usp=drive_link",
},
{
  id: 87,
  title: "Sets, Relations and Functions",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1u7MN99zkO9AZXFcK1fDneIp7jXNbS1-G/view?usp=drive_link",
},
{
  id: 88,
  title: "Permutations and Combinations",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1OsXybjl7vpKDGZKW6IPz6lkswdhOep-7/view?usp=drive_link",
},
{
  id: 89,
  title: "Matrices and Determinants",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/145sQzbCuMSZdnwawhbOQPhLTlosmDUQ_/view?usp=drive_link",
},
{
  id: 90,
  title: "Complex Numbers and Quadratic Equations",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1zBpgjhOifc5-ACZ8TrsvDhJiSoiR3ggx/view?usp=drive_link",
},
{
  id: 91,
  title: "Binomial Theorem and Its Simple Applications",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1mHOAiNcl3mDKcwTUWvJnoJyzjFgAT9M_/view?usp=drive_link",
},
{
  id: 92,
  title: "Some basic Concepts in Chemistry",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/141qc2LWCl43EnwCUXlJF-ZmrrKKDwoyw/view?usp=drive_link",
},
{
  id: 93,
  title: "Solutions",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1tvGp7z_3LNaeISs8d5GllSEmZhOXVMh8/view?usp=drive_link",
},
{
  id: 94,
  title: "Chemical Thermodynamics",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1RoNbzoV0mCrEzieCf021DJK5yKVH04w8/view?usp=drive_link",
},
{
  id: 95,
  title: "Chemical Bonding and Molecular Structure",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1BTfsvOWvkX1_uAIO3RjWWsqeMj_u2C0b/view?usp=drive_link",
},
{
  id: 96,
  title: "Atomic Structure",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1BTfsvOWvkX1_uAIO3RjWWsqeMj_u2C0b/view?usp=drive_link",
},{
  id: 97,
  title: "Sequence and Series",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1-6__XI_DxOHf_AlrARq_FCqkbnOdIgLU/view?usp=drive_link",
},
{
  id: 98,
  title: "Oscillations and Waves",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1BYovhckcjIArFoSaDTJw--RBQ_GT-Q2V/view?usp=drive_link",
},
{
  id: 99,
  title: "Limit, Continuity ad Differentiability",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1CwWkVycEqHnMtrJiKAjKOGRZZYJmo__J/view?usp=drive_link",
},
{
  id: 100,
  title: "Differential Equations",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1G0R5VX6hqgCDzSbMmDo4RRPaFR9ICkh_/view?usp=drive_link",
},
{
  id: 101,
  title: "Properties of Solids and Liquids",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1Q4WKAe5cadelU7_9Wp91dgP12dMoD-Gr/view?usp=drive_link",
},
{
  id: 102,
  title: "Integral Calculus",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1_H477h8ajTZdtYJWbjqji_9plCFZ9njl/view?usp=drive_link",
},
{
  id: 103,
  title: "Kinetic Theory of Gases",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1eOEYFoRfQXMiejw8BugcJ_O97E63US_K/view?usp=drive_link",
},
{
  id: 104,
  title: "Gravitation",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1wHsW4locQGe0kkKw2GR6k0xy9yLh6toQ/view?usp=drive_link",
},
{
  id: 105,
  title: "Co-ordinate Geometry",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/16mXhYZOziZNrw70KknmBK444HBu6_fT2/view?usp=drive_link",
},
{
  id: 106,
  title: "Redox Reactions and Electrochemistry",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1HFI60DSwrgWfYrXTCfhqOdVt6kn7fgQl/view?usp=drive_link",
},
{
  id: 107,
  title: "Classification of Elements and Periodicity in properties",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1V7uGF_Z3gaVIc6SD66K16OcJ1LarLC73/view?usp=drive_link",
},
{
  id: 108,
  title: "Chemical Kinetics",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1VxNX_cTaT8d_LqTnRwm0H6yjhtrX6HMM/view?usp=drive_link",
},
{
  id: 109,
  title: "Thermodynamics",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1YPGrsR0sIytuXohbnrd4C_6aN_WmR7zH/view?usp=drive_link",
},
{
  id: 110,
  title: "Equilibrium",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1hib_s4WB28PhlQVoerVpuPhHhCJly9JO/view?usp=drive_link",
},
{
  id: 111,
  title: "p-Block Elements",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1lWruw_da_Eo2LOZRJezzrDojx2rCoDkI/view?usp=drive_link",
},{
  id: 112,
  title: "Current Electricity",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1-aL-Ur1EQhMoqMlV32E6WpKQWoZz4i39/view?usp=drive_link",
},
{
  id: 113,
  title: "Trigonometry",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/15qDOHKQIE3NyUTx3CaVlueA6IZvM5qjK/view?usp=drive_link",
},
{
  id: 114,
  title: "Purification and Characterisation of Organic Compounds",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1B7Nd_dOW-O9aMRI8SeKRPiYFiqVpdrDk/view?usp=drive_link",
},
{
  id: 115,
  title: "Electronic Devices",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1CYYG2fzqaXlalnAfAzZXJ8VXY8VEO0oi/view?usp=drive_link",
},
{
  id: 116,
  title: "Electromagnetic Induction and Alternating Currents",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1D6zMzzV34nXsrEzU3SsxT7-y78j2po5v/view?usp=drive_link",
},
{
  id: 117,
  title: "Optics",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1DODACCVZ3AE7C6PjDXSXtdn2kMEWrZwU/view?usp=drive_link",
},
{
  id: 118,
  title: "Magnetic Effects of Current and Magnetism",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1K0YDxmQFAPBf4dQ8AIrK28OmlpNouWAB/view?usp=drive_link",
},
{
  id: 119,
  title: "Organic Compounds Containing Oxygen",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1NiA9rcymJQOZBQplAy-Nx_yyhDk413X8/view?usp=drive_link",
},
{
  id: 120,
  title: "Principles Related to Practical Chemistry",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1TLiDSG0XMkoYf_LHisTe2t-iLFj055wH/view?usp=drive_link",
},
{
  id: 121,
  title: "Electromagnetic Waves",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1X8PeedTxMh83m40r4aIYP494bJuOqEAL/view?usp=drive_link",
},
{
  id: 122,
  title: "Statistics and Probability",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1awAo0cDNGZmoX93giFJqQxVgY2KyqtkO/view?usp=drive_link",
},
{
  id: 123,
  title: "Vector Algebra",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1fnJWv8C9jn8r_gLl8mL8wH1BzOy1O8XA/view?usp=drive_link",
},
{
  id: 124,
  title: "Organic Compounds Containing Halogens",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1hREyL9K6jafzJu_lQFXWoZC2M9ARRiun/view?usp=drive_link",
},
{
  id: 125,
  title: "Three Dimensional Geometry",
  type: "Practice",
  subject: "Mathematics",
  downloadUrl: "https://drive.google.com/file/d/1k4uIAWGiqXohp5bMOhFhRh37DYtjJ87R/view?usp=drive_link",
},
{
  id: 126,
  title: "Experimental Skills",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1k5VcQj0OAS4kKB4VYM-r-Mqv01K_HMSt/view?usp=drive_link",
},
{
  id: 127,
  title: "Atoms and Nuclei",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1oHIBI33EYZ10ZXGGW1VxQAsTIBuF2zLH/view?usp=drive_link",
},
{
  id: 128,
  title: "Coordination Compounds",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1oc51qVSyX47z6JUsE7MiVVv9eMPfaRI9/view?usp=drive_link",
},
{
  id: 129,
  title: "Some Basic Principles of Organic Chemistry",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1pVI6qAPZv6saV1QKK7FZ-sHbcNZsVKhh/view?usp=drive_link",
},
{
  id: 130,
  title: "Biomolecules",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1pcBMXlnb03t16vFfpp3VKjGxHBD1HPhK/view?usp=drive_link",
},
{
  id: 131,
  title: "Dual Nature of Matter and Radiation",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1qmI5Kl67hku14zqWYgPILSo9NDn6DG3G/view?usp=drive_link",
},
{
  id: 132,
  title: "Organic Compounds Containing Nitrogen",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1sTj0AzF9ql8AdPJIvzJqBarIoFDEl0Cy/view?usp=drive_link",
},
{
  id: 133,
  title: "d- and f-Block Elements",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1sYMYO36nurMnpwhOOMLHg0DQLa0G3KTb/view?usp=drive_link",
},
{
  id: 134,
  title: "Electrostatics",
  type: "Practice",
  subject: "Physics",
  downloadUrl: "https://drive.google.com/file/d/1wfLexpynJTfU7-Wl9Xfj4Wo1bjstSacy/view?usp=drive_link",
},
{
  id: 135,
  title: "Hydrocarbons",
  type: "Practice",
  subject: "Chemistry",
  downloadUrl: "https://drive.google.com/file/d/1CadR53RAzidBP-l5rHrmAHCCgkRm3ase/view?usp=drive_link",
},
{
  id: 136,
  title: "Class 11 JEE Syllabus Timeline",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/17tmaxBLKOK7GkIK_FJd_JAzaolDgRnJO/view?usp=drive_link",
},
{
  id: 137,
  title: "Class 12 JEE Syllabus Timeline",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/19Z4TTBjrObRzLeFUGcoEOE8K1c0uGQSq/view?usp=drive_link",
},
{
  id: 138,
  title: "Engineering Exams Timeline",
  type: "JEE Busters",
  subject: "All",
  downloadUrl: "https://drive.google.com/file/d/1PqLdlh24eilNZjO3TbnQAYoxUJaWAoDA/view?usp=drive_link",
}
];
